import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getSavedSimulations, toggleTimelineActive, switchClient } from '../../actions/dataAction';
import { auth } from '../../firebase';
import { getUser, getUserProfile } from '../../actions/userAction';
import { updateData, newSimulation, exitSimulation, loadSimulation, saveSimulation } from '../../actions/dataAction';
import DataEditor from './detailViews/DataEditor';
import styled from 'styled-components';
import Popover, {PopoverAnimationVertical} from 'material-ui/Popover';
import FlatButton from 'material-ui/FlatButton';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import SavedSimulations from './SavedSimulations';
import Dialog from 'material-ui/Dialog';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown';
import moment from 'moment';

import {Box, BoxButton, MainHeading, SubHeading} from '../StyledComponents';

const IndexViewContainer = styled.div`
  display: flex;
  flex: 1 1 auto;

  @media only screen and (max-width: 991px) {
    min-height: 500px;
  }

  @media only screen and (max-width: 767px) {
    min-height: initial;
  }

  /*@media print {
    min-height: 500px;
  }*/
`;

const AngleDown = styled(FontAwesomeIcon)`
    margin-left:10px;
`;

const modalStyleSaveDialog = {
  maxWidth: '400px',
}

const modalStyleOpenDialog = {
  maxWidth: '700px',
}

const modalStyleEditDialog = {
  maxWidth: '1200px',
}

const StyledMenuItem = styled(MenuItem)`
  min-height: 20px !important;
  line-height: 30px !important;
  font-size: 12px !important;
  text-align: center;
`;

const EditButton = styled(BoxButton) `
  min-width:30px;
  float:right;
`;


class IndexView extends Component {
    constructor(props) {
      super(props);
      this.state = {
        simulationDropdownOpen: false,
        brandDropdownOpen: false,
        saveDialogOpen: false,
        loadDialogOpen: false
      };
      this.handleChangeSimulationName = this.handleChangeSimulationName.bind(this);

    }
    updateData() {
        this.props.updateData("Data updated " + Date.now());
    }

    componentDidMount() {
      this.props.getSavedSimulations();
    }

    handleClickSimulationButton = (event) => {
      event.preventDefault();
      if (this.props.data.simulationMode) {
        this.setState({
            saveDialogOpen: true,
        });
      } else {
        this.setState({
            simulationDropdownOpen: true,
            anchorEl: event.currentTarget,
        });
      }
    };

    handleCloseSimulationDropdown = () => {
      this.setState({
        simulationDropdownOpen: false,
      });
    };

    handleCloseBrandDropdown = () => {
      this.setState({
        brandDropdownOpen: false,
      });
    };

    handleClickBrandDropdown = (event) => {
      this.setState({
        brandDropdownOpen: !this.state.brandDropdownOpen,
        brandAnchorEl: event.currentTarget,
      });
    };

    handleOpenLoadDialog = () => {
      this.setState({loadDialogOpen: true, simulationDropdownOpen: false});
    };

    handleCloseLoadDialog = () => {
      this.setState({loadDialogOpen: false});
    };

    handleOpenSaveDialog = () => {
      this.setState({saveDialogOpen: true});
    };

    handleCloseSaveDialog = () => {
      this.setState({saveDialogOpen: false});
    };

    handleCloseEditDialog = () => {
      this.setState({editDialogOpen: false});
    };

    newSimulation = (event) => {
      this.setState({
        simulationDropdownOpen: false,
      });
      this.props.newSimulation();
    }

    handleChangeSimulationName(event) {
      const simulationName = event.target.value;
      this.setState({ simulationName });
    }

    handleSaveSimulation() {
      const _dataEnsureNotUndefined = this.props.data.variableData ? JSON.parse(JSON.stringify(this.props.data.variableData)) : [];
      const _simulationParamsEnsureNotUndefined = this.props.data.simulationParams ? JSON.parse(JSON.stringify(this.props.data.simulationParams)) : {};
      this.props.saveSimulation({title: this.state.simulationName, createdOn: new Date().toString(), data: _dataEnsureNotUndefined, simulationParams: _simulationParamsEnsureNotUndefined, userId:auth.currentUser.uid});
      this.setState({saveDialogOpen: false});
    }

    savedSimulationsList = () => {
      let items = [];
      let simulations = this.props.data.simulations ? this.props.data.simulations:{};
      for (var key in simulations) {
        if (simulations.hasOwnProperty(key)) {
          items.push(<p>{simulations[key].title}</p>);
        }
      }
      return (<div>{items.length ? items : (<p>No simulations</p>)}</div>);
    }

    timelineActive() {
      return process.env.REACT_APP_TIMELINE_ACTIVE === "true";
    }

    switchBrand(b) {
      switchClient(b);
      window.location.reload();
    }

    brandSwitcher() {
      if (this.props.user && this.props.user.userProfile && this.props.user.userProfile.brands) {
        const brands = this.props.user.userProfile.brands;
        return (
          <div>
          <BoxButton
          onClick={this.handleClickBrandDropdown}
          className="margin-right hidden-xs"
        >
        BRANDS
        <AngleDown icon={faAngleDown} />
        </BoxButton>
          <Popover
            open={this.state.brandDropdownOpen}
            anchorEl={this.state.brandAnchorEl}
            anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'left', vertical: 'top'}}
            onRequestClose={this.handleCloseBrandDropdown}
            animation={PopoverAnimationVertical}
          >
            <Menu>
              {brands.map((b, i) => <StyledMenuItem primaryText={b} onClick={() => this.switchBrand(b)} />)}
            </Menu>
          </Popover>
          </div>
        );
      }
    }

    render() {
        const { data, user } = this.props;
        const { simulationName } = this.state;

        if (!data) {
          return <Box/>;
        };

        const saveDialogActions = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.handleCloseSaveDialog}
            key="cancel"
          />,
          <FlatButton
            label="Save"
            type="submit"
            primary={true}
            key="save"
          />,
        ];

        const loadDialogActions = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.handleCloseLoadDialog}
            key="cancel"
          />
        ];

        const editDialogActions = [
          <FlatButton
            label="Cancel"
            primary={true}
            onClick={this.handleCloseEditDialog}
            key="cancel"
          />
        ];

        return (
          <Box {...this.props}>

            <IndexViewContainer>
              <div className="" style={{flex:'1',display:'flex',flexDirection:'column'}}>
                  <div style={{flex:'0'}}>
                    <MainHeading big style={{display:'block'}} mb0={this.props.subTitle ? true:false}>{/* clientName*/} {this.props.title}</MainHeading>
                    {this.props.subTitle && <SubHeading style={{display:'block'}}>{this.props.subTitle}</SubHeading>}

                      {(user.userProfile && user.userProfile.isAdmin && (
                        <EditButton
                          onClick={() => this.setState({editDialogOpen: !this.state.editDialogOpen})}
                          className=""
                        >
                            <span>&#9776;</span>
                        </EditButton>
                      ))||null}

                        {/*
                          <BoxButton
                            onClick={() => this.props.history.push('/portfolio')}
                            className="margin-right hidden-xs"
                          >
                              <span>Portfolio</span>
                          </BoxButton>
                        */}

                          {this.brandSwitcher()}

                          <BoxButton
                            onClick={() => this.props.history.push('/dashboard')}
                            className="margin-right hidden-xs"
                            primary
                          >
                            <span>Dashboard</span>
                          </BoxButton>

                          {this.timelineActive() && (
                            <BoxButton
                              onClick={() => this.props.toggleTimelineActive(this.props.data.timelineActive ? false:true)}
                              className="margin-right hidden-xs"
                            >
                            {moment(data.endDate).format("YYYY-MM-DD")}
                          </BoxButton>
                          )}

                          <Popover
                            open={this.state.simulationDropdownOpen && !this.props.data.simulationMode}
                            anchorEl={this.state.anchorEl}
                            anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                            targetOrigin={{horizontal: 'left', vertical: 'top'}}
                            onRequestClose={this.handleCloseSimulationDropdown}
                            animation={PopoverAnimationVertical}
                          >
                            <Menu>
                              <StyledMenuItem primaryText="New" onClick={this.newSimulation} />
                              <StyledMenuItem primaryText="Load existing" onClick={this.handleOpenLoadDialog} />
                            </Menu>
                          </Popover>
                  </div>


                  <Dialog
                    title="Save simulation"
                    modal={false}
                    open={this.state.saveDialogOpen || false}
                    onRequestClose={this.handleCloseSaveDialog}
                    contentStyle={modalStyleSaveDialog}
                  >

                    <ValidatorForm
                        ref="form"
                        onSubmit={() => this.handleSaveSimulation()}
                        onError={errors => console.log(errors)}
                    >
                        <TextValidator
                            floatingLabelText="Simulation name"
                            onChange={this.handleChangeSimulationName}
                            name="name"
                            value={simulationName}
                            validators={['required']}
                            errorMessages={['This field is required']}
                        />
                        <div style={{ textAlign: 'right', padding: 8, margin: '24px -24px -24px -24px' }}>
                          {saveDialogActions}
                        </div>
                    </ValidatorForm>
                  </Dialog>

                  <Dialog
                    title="Load simulation"
                    modal={false}
                    open={this.state.loadDialogOpen || false}
                    onRequestClose={this.handleCloseLoadDialog}
                    contentStyle={modalStyleOpenDialog}
                  >

                    <SavedSimulations close={this.handleCloseLoadDialog}/>

                    <div style={{ textAlign: 'right', padding: 8, margin: '24px -24px -24px -24px' }}>
                      {loadDialogActions}
                    </div>
                  </Dialog>

              </div>
            </IndexViewContainer>


            <Dialog
              title="Data Editor"
              modal={false}
              open={this.state.editDialogOpen || false}
              onRequestClose={this.handleCloseEditDialog}
              contentStyle={modalStyleEditDialog}
            >
              <DataEditor/>
              <div style={{ textAlign: 'right', padding: 8, margin: '24px -24px -24px -24px' }}>
                {editDialogActions}
              </div>
            </Dialog>
          </Box>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        user: state.user,
        data: state.data
    };
}

export default withRouter(connect(mapStateToProps, { getUser, getUserProfile, updateData, newSimulation, exitSimulation,loadSimulation, saveSimulation, getSavedSimulations, toggleTimelineActive })(IndexView));



// WEBPACK FOOTER //
// ./src/components/dataViews/BrandHealthMenu.js